<template>
    <div>
        <h1>Rewards Page</h1>
        <canvas ref="canvas" style="background:black;" id='canvas1' ></canvas>

    </div>
</template>

<script>
// import ConfirmDialogue from '../global/popup/ConfirmDialog.vue';

export default {
 name: "Prizes",
    // components: { ConfirmDialogue },
    mounted(){
        // this.init();
        this.drawFractalChat();
    },
       data() {
        return {
            maxLevel: 4,
            spread: 0,
        }
    },
    methods: {
        init() {
            const canvas = document.getElementById('canvas1');
            const ctx = canvas.getContext('2d');
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;

            //canvas settings
            ctx.fillStyle = 'green';
            ctx.strokeStyle = 'yellow';
            ctx.lineWidth = 30;
            ctx.lineCap = 'round';

            //effect settings'
            // let size = 200;
            ctx.save();

            ctx.translate(400,200);
            ctx.scale(1,1);
            ctx.rotate(0);

            //ctx.fillRect(50, 50,100,100);
            // ctx.restore();
            let sides = 5;
            let size = 200;
            let level =3;
            let branches = 2;
            let scale = 0.2;

            // for(let i = 0; i<sides; i++) {
            //     ctx.beginPath();
            //     ctx.moveTo(0, 0);
            //     ctx.lineTo(size, 0);
            //     ctx.stroke();
            //     ctx.rotate(Math.PI *2/sides);
            // ctx.scale(0.99, 0.99);
            // ctx.translate(30,50);
            // }
            this.drawBranch(ctx, size, level, branches, scale);
            ctx.restore();
            this.drawFractal(ctx, 25, size, level, branches, canvas);
        },
        drawBranch(ctx, size, level, branches, scale) {
            if(level > this.maxLevel) return;
            ctx.beginPath();
            ctx.moveTo(0, 0);
            ctx.lineTo(size, 0);
            ctx.stroke();
            for(let i = 0; i< branches; i++) {
                ctx.save();
                ctx.translate(size, - (size/branches) * i, 0);
                ctx.rotate(this.spread);

            // ctx.scale(scale, scale);
            ctx.scale(.99, .99);
            this.drawBranch(ctx, size, level+1);
            ctx.restore();

            ctx.save();
            ctx.translate(size - (size/branches) *i, 0);
            ctx.rotate(-this.spread);
            ctx.scale(scale, scale);
            // ctx.scale(s, .99);
            this.drawBranch(ctx, size, level+1);
            ctx.restore();
            }
        },
        drawFractal(ctx, sides, size, level, branches, canvas) {
            ctx.save();
            ctx.translate(canvas.width/2, canvas.height/2);
            ctx.scale(1,1);
            ctx.rotate(0);
            for(let i = 0; i< sides; i++) {
                ctx.rotate((Math.PI * 2)/sides);
                this.drawBranch(ctx, size, level, branches)
            }
            ctx.restore();
        },

drawFractalChat() {
      const canvas = this.$refs.canvas;
      const context = canvas.getContext("2d");

  canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
      const width = canvas.width;
      const height = canvas.height;


      // Generate random color for the fractal
      const randomColor = "#" + ((Math.random() * 0xffffff) << 0).toString(16);

      // Clear the canvas
      context.clearRect(0, 0, width, height);

      // Draw the fractal
      this.drawFractalRecursive(0, 0, width, height, randomColor, context);
    },
    drawFractalRecursive(x, y, width, height, color, context) {
      // Base case: stop recursion when the width or height is smaller than a threshold value
      if (width < 5 || height < 5) {
        return;
      }

      // Draw a rectangle with random color
      context.fillStyle = color;
//   context.rotate((Math.PI * 2)/4);
      context.fillRect(x, y, width, height);

      // Divide the rectangle into four smaller rectangles
      const smallerWidth = width / 2;
      const smallerHeight = height / 2;

      // Generate random colors for the smaller rectangles
      const color1 = "#" + ((Math.random() * 0xffffff) << 0).toString(16);
      const color2 = "#" + ((Math.random() * 0xffffff) << 0).toString(16);
      const color3 = "#" + ((Math.random() * 0xffffff) << 0).toString(16);
      const color4 = "#" + ((Math.random() * 0xffffff) << 0).toString(16);

      // Recursively draw the smaller rectangles
      this.drawFractalRecursive(x, y, smallerWidth, smallerHeight, color1, context);
      this.drawFractalRecursive(
        x + smallerWidth,
        y,
        smallerWidth,
        smallerHeight,
        color2,
        context
      );
      this.drawFractalRecursive(
        x,
        y + smallerHeight,
        smallerWidth,
        smallerHeight,
        color3,
        context
      );
      this.drawFractalRecursive(
        x + smallerWidth,
        y + smallerHeight,
        smallerWidth,
        smallerHeight,
        color4,
        context
      );
    },
    }
}

//UPTO : https://youtu.be/dQKYao-daYw?t=1424  (fRANKS lABORATORY)
</script>

<style scoped>
body {
margin:0;
padding:0;
box-sizing:border-box;
}
#canvas{
background:blue;

}
.delete-btn {
    padding: 0.5em 1em;
    background-color: #eccfc9;
    color: #c5391a;
    border: 2px solid #ea3f1b;
    border-radius: 5px;
    font-weight: bold;
    font-size: 16px;
    text-transform: uppercase;
    cursor: pointer;
}
</style>
